import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Config from "../Config.json";
import { useNavigate, useLocation } from "react-router-dom";

import { useTranslation } from "react-i18next";

const Aitools = () => {
  const TITLE = Config.SITE_TITLE + " | AITools";
  const DESC = "Create a React App from an HTML Website.";
  const CANONICAL = Config.SITE_DOMAIN + "/";

  const { t } = useTranslation(); // használjuk a useTranslation hookot a fordításhoz
  const navigate = useNavigate();
  const location = useLocation();
  const language = location.pathname.split("/")[1]; // Extracts language from URL

  const [filteredArticles, setFilteredArticles] = useState([]);
  const [counters, setCounters] = useState({});

  const calculateElapsedTime = (timeString) => {
    const publicationDate = new Date(timeString);
    const now = new Date();
    const diffInMs = now - publicationDate;

    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInMinutes < 60) {
      return `${diffInMinutes} minutes ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hours ago`;
    } else {
      return `${diffInDays} days ago`;
    }
  };

  useEffect(() => {
    const fetchArticles = async () => {
      console.log(
        `Fetching articles with language: ${language} and category: 2`
      );
      // Log to file (if applicable in the environment)
      fetch("/log", {
        method: "POST",
        body: JSON.stringify({ language, category: 2 }),
      });
    };

    fetchArticles();
  }, [language]);

  useEffect(() => {
    const storedCounters = localStorage.getItem("articleCounters");
    if (storedCounters) {
      setCounters(JSON.parse(storedCounters));
    } else {
      const initialCounters = {};
      filteredArticles.forEach((article) => {
        initialCounters[article.ID] = { likes: 0, dislikes: 0 };
      });
      setCounters(initialCounters);
    }
  }, [filteredArticles]);

  useEffect(() => {
    if (Object.keys(counters).length > 0) {
      localStorage.setItem("articleCounters", JSON.stringify(counters));
    }
  }, [counters]);

  const handleLike = (articleId) => {
    setCounters((prevCounters) => ({
      ...prevCounters,
      [articleId]: {
        likes: (prevCounters[articleId]?.likes || 0) + 1,
        dislikes: prevCounters[articleId]?.dislikes || 0,
      },
    }));
  };

  const handleDislike = (articleId) => {
    setCounters((prevCounters) => ({
      ...prevCounters,
      [articleId]: {
        likes: prevCounters[articleId]?.likes || 0,
        dislikes: (prevCounters[articleId]?.dislikes || 0) + 1,
      },
    }));
  };

  const handleReadMore = (articleId) => {
    navigate("/article", { state: { articleId } });
  };

  return (
    <main className="main-content">
      <Helmet>
        <title>{TITLE}</title>
        <link rel="canonical" href={CANONICAL}></link>
        <meta name="description" content={DESC} />
        <meta name="theme-color" content={Config.THEME_COLOR} />
      </Helmet>
      <button id="TopBtn" title="Go to top">
        &#10224;
      </button>
      <div className="container ai-container">
        <div>
          <h2>
            <b>{t("AiToolsTitle")}</b>
          </h2>
          <h3>
            <b>{t("AiToolsTitleH31")}</b>
          </h3>
          <p>
            <b>{t("AiToolsTitleHp1")}</b>
          </p>{" "}
          <h3>
            <b>{t("AiToolsTitleH32")}</b>
          </h3>
          <p>{t("AiToolsTitleH32")}</p>
          <ul>
            <li>
              <b>{t("AiToolsTitleLi11")}</b>
              {t("AiToolsTitleLi111")}
            </li>
            <li>
              <b>{t("AiToolsTitleLi12")}</b>
              {t("AiToolsTitleLi121")}
            </li>
            <li>
              <b>{t("AiToolsTitleLi13")}</b>
              {t("AiToolsTitleLi131")}
            </li>
            <li>
              <b>{t("AiToolsTitleLi14")}</b>
              {t("AiToolsTitleLi141")}
            </li>
            <li>
              <b>{t("AiToolsTitleLi15")}</b>
              {t("AiToolsTitleLi151")}
            </li>
          </ul>
          <h3>
            <b>{t("AiToolsTitleH33")}</b>
          </h3>
          <p>{t("AiToolsTitleHp3")}</p>{" "}
          <h4>
            <b>{t("AiToolsTitleH41")}</b>
          </h4>
          <ul>
            <li>
              <b>{t("AiToolsTitleLi16")}</b>
              {t("AiToolsTitleLi161")}
            </li>
            <li>
              <b>{t("AiToolsTitleLi17")}</b>
              {t("AiToolsTitleLi171")}
            </li>
            <li>
              <b>{t("AiToolsTitleLi18")}</b>
              {t("AiToolsTitleLi181")}
            </li>
          </ul>
          <h4>
            <b>{t("AiToolsTitleH42")}</b>
          </h4>{" "}
          <ul>
            <li>
              <b>{t("AiToolsTitleLi19")}</b>
              {t("AiToolsTitleLi191")}
            </li>
            <li>
              <b>{t("AiToolsTitleLi20")}</b>
              {t("AiToolsTitleLi201")}
            </li>
          </ul>
          <h4>
            <b>{t("AiToolsTitleH43")}</b>
          </h4>{" "}
          <ul>
            <li>
              <b>{t("AiToolsTitleLi21")}</b>
              {t("AiToolsTitleLi211")}
            </li>
            <li>
              <b>{t("AiToolsTitleLi22")}</b>
              {t("AiToolsTitleLi221")}
            </li>
          </ul>
          <h4>
            <b>{t("AiToolsTitleH44")}</b>
          </h4>
          <ul>
            <li>
              <b>{t("AiToolsTitleLi23")}</b>
              {t("AiToolsTitleLi231")}
            </li>
            <li>
              <b>{t("AiToolsTitleLi24")}</b>
              {t("AiToolsTitleLi241")}
            </li>
          </ul>
          <h3>
            <b>{t("AiToolsTitleH34")}</b>
          </h3>{" "}
          <p dangerouslySetInnerHTML={{ __html: t("AiToolsTitleHp4") }}></p>
        </div>
        <div className="row g-3">
          {filteredArticles.map((article) => (
            <div className="col-sm-12 col-md-6 col-lg-4" key={article.ID}>
              <div className="card h-100">
                <img
                  src={article.img}
                  className="card-img-top"
                  alt={article.alt}
                />
                <div className="card-body">
                  <h5 className="card-title">{article.title}</h5>
                  <p className="card-text text-truncate">{article.teaser}</p>
                  <p className="text-muted">
                    Published: {calculateElapsedTime(article.time)}
                  </p>
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-outline-success btn-sm"
                      onClick={() => handleLike(article.ID)}
                    >
                      👍 {counters[article.ID]?.likes || 0}
                    </button>
                    <button
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => handleDislike(article.ID)}
                    >
                      👎 {counters[article.ID]?.dislikes || 0}
                    </button>
                  </div>
                  <button
                    onClick={() => handleReadMore(article.ID)}
                    className="btn btn-AIinsideLife-primary w-100 mt-2"
                  >
                    Read More...
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default Aitools;
